module.exports = __webpack_public_path__ + "static/cetmen-web-ab30f24c7b2e395173b93af397f8a81c.jpg";